import Close from '@vtex/styleguide/lib/icon/Close';
import { useToggle } from '../../Drawer/hooks/useToggle';
import { useDrawerCloseButton } from '../hooks/useDrawerCloseButton';

const DrawerCloseButtonContainer = () => {
	const { toggle } = useToggle();
	const { blockClass, componentId } = useDrawerCloseButton();
	return (
		<div
			data-selection={componentId}
			className={`flex closeIconContainer closeIconContainer--${blockClass} vtex-store-drawer-0-x-closeIconContainer vtex-store-drawer-0-x-closeIconContainer--${blockClass}`}
		>
			<button
				onClick={() => toggle && toggle()}
				className={`closeIconButton closeIconButton--${blockClass} vtex-store-drawer-0-x-closeIconButton vtex-store-drawer-0-x-closeIconButton--${blockClass} pa4 pointer bg-transparent transparent bn pointer`}
			>
				<Close />
			</button>
		</div>
	);
};

export default DrawerCloseButtonContainer;
